(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-cart-drawer]');
    if (!root) return;

    const panel = root.querySelector('[data-cart-drawer-panel]');
    const overlay = root.querySelector('[data-cart-drawer-overlay]');
    const toggles = document.querySelectorAll('[data-cart-toggle]');
    const hoverMedia = window.matchMedia('(hover: hover) and (pointer: fine)');

    let openTimer = null;
    let closeTimer = null;
    let isOpen = false;

    function open(focusPanel) {
      clearTimeout(closeTimer);
      if (isOpen) return;
      isOpen = true;
      root.hidden = false;
      requestAnimationFrame(() => root.classList.add('is-open'));
      document.documentElement.setAttribute('data-cart-drawer-open', '');
      if (focusPanel) panel.focus();
    }

    function close() {
      clearTimeout(openTimer);
      clearTimeout(closeTimer);
      if (!isOpen) return;
      isOpen = false;
      root.classList.remove('is-open');
      document.documentElement.removeAttribute('data-cart-drawer-open');
      setTimeout(() => {
        if (!isOpen) root.hidden = true;
      }, 260);
    }

    function scheduleClose() {
      clearTimeout(closeTimer);
      closeTimer = setTimeout(close, 400);
    }

    async function refresh() {
      const response = await fetch(`${window.Shopify.routes.root}?section_id=cart-drawer`);
      if (!response.ok) throw new Error(`Cart drawer refresh failed: ${response.status}`);
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const fresh = html.querySelector('[data-cart-drawer]');
      if (!fresh) return;
      const freshPanel = fresh.querySelector('[data-cart-drawer-panel]');
      panel.replaceChildren(...freshPanel.childNodes);
      root.dataset.cartItemCount = fresh.dataset.cartItemCount;
      const count = parseInt(fresh.dataset.cartItemCount, 10);
      document.querySelectorAll('[data-cart-count]').forEach((el) => {
        el.textContent = count > 0 ? ` (${count})` : '';
      });
    }

    toggles.forEach((toggle) => {
      toggle.addEventListener('click', (event) => {
        event.preventDefault();
        clearTimeout(openTimer);
        open(true);
      });

      toggle.addEventListener('mouseenter', () => {
        if (!hoverMedia.matches) return;
        clearTimeout(closeTimer);
        openTimer = setTimeout(() => open(false), 120);
      });

      toggle.addEventListener('mouseleave', () => {
        clearTimeout(openTimer);
        if (isOpen) scheduleClose();
      });
    });

    panel.addEventListener('mouseenter', () => clearTimeout(closeTimer));
    panel.addEventListener('mouseleave', () => {
      if (hoverMedia.matches) scheduleClose();
    });

    overlay.addEventListener('click', close);

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && isOpen) close();
    });

    panel.addEventListener('click', async (event) => {
      const closeButton = event.target.closest('[data-cart-drawer-close]');
      if (closeButton) {
        close();
        return;
      }

      const qtyButton = event.target.closest('[data-cart-qty-change]');
      if (!qtyButton) return;
      qtyButton.disabled = true;
      try {
        const response = await fetch(`${window.Shopify.routes.root}cart/change.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            line: parseInt(qtyButton.dataset.line, 10),
            quantity: parseInt(qtyButton.dataset.cartQtyChange, 10),
          }),
        });
        if (!response.ok) throw new Error(`Cart change failed: ${response.status}`);
        await refresh();
      } finally {
        if (qtyButton.isConnected) qtyButton.disabled = false;
      }
    });

    document.addEventListener('cart:changed', async (event) => {
      await refresh();
      if (event.detail && event.detail.open) open(false);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gallery"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.gallery').forEach((gallery) => {
    const section = gallery.closest('.shopify-section') || document;
    const overlay = section.querySelector('[data-gallery-overlay]');
    if (!overlay) return;

    const slides = Array.from(overlay.querySelectorAll('[data-gallery-slide]'));
    const panel = overlay.querySelector('.gallery-overlay__panel');
    let current = 0;

    function sizePanel(slide) {
      panel.style.maxHeight = '';
      panel.scrollTop = 0;
      const text = slide.querySelector('.gallery-overlay__text');
      if (!text) return;
      const anchor = slide.querySelector('.gallery-overlay__title') || slide.querySelector('.gallery-overlay__media');
      requestAnimationFrame(() => {
        const cap = parseFloat(getComputedStyle(panel).maxHeight);
        const desired =
          anchor.getBoundingClientRect().bottom -
          panel.getBoundingClientRect().top +
          parseFloat(getComputedStyle(panel).paddingBottom);
        if (!Number.isNaN(cap) && !Number.isNaN(desired)) {
          panel.style.maxHeight = `${Math.round(Math.min(desired, cap))}px`;
        }
        panel.scrollTop = 0;
      });
    }

    function stopVideo(stage) {
      const video = stage.querySelector(':scope > video');
      if (video) video.pause();
      stage.classList.remove('is-playing');
    }

    function resetSlide(slide) {
      const stage = slide.querySelector('[data-overlay-stage]');
      if (stage) stopVideo(stage);
    }

    function show(index) {
      current = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        slide.hidden = i !== current;
        resetSlide(slide);
      });
      sizePanel(slides[current]);
    }

    gallery.querySelectorAll('[data-gallery-open]').forEach((item) => {
      item.addEventListener('click', () => {
        show(parseInt(item.dataset.galleryOpen, 10));
        overlay.showModal();
      });
    });

    overlay.addEventListener('close', () => {
      slides.forEach(resetSlide);
      panel.style.maxHeight = '';
    });

    overlay.addEventListener('click', (event) => {
      const play = event.target.closest('[data-overlay-play]');
      if (play) {
        const stage = play.closest('[data-overlay-stage]');
        let video = stage.querySelector(':scope > video');
        if (!video) {
          const template = stage.querySelector('[data-overlay-video-template]');
          stage.appendChild(template.content.cloneNode(true));
          video = stage.querySelector(':scope > video');
          video.addEventListener('click', () => stopVideo(stage));
        }
        stage.classList.add('is-playing');
        video.play();
        return;
      }

      if (event.target.closest('[data-gallery-prev]')) {
        show(current - 1);
        return;
      }

      if (event.target.closest('[data-gallery-next]')) {
        show(current + 1);
        return;
      }

      if (event.target === overlay) overlay.close();
    });

    overlay.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') show(current - 1);
      if (event.key === 'ArrowRight') show(current + 1);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  document.querySelectorAll('.header').forEach((header) => {
    const burger = header.querySelector('.header__burger');
    const drawer = header.querySelector('.header__drawer');
    if (!burger || !drawer) return;

    function closeDrawer() {
      if (drawer.classList.contains('is-closing')) return;
      drawer.classList.add('is-closing');
      setTimeout(() => {
        drawer.classList.remove('is-closing');
        drawer.close();
      }, 230);
    }

    burger.addEventListener('click', () => drawer.showModal());

    drawer.addEventListener('cancel', (event) => {
      event.preventDefault();
      closeDrawer();
    });

    drawer.querySelector('.header__drawer-close').addEventListener('click', closeDrawer);

    const cartLink = drawer.querySelector('[data-drawer-cart]');
    if (cartLink) {
      cartLink.addEventListener('click', (event) => {
        const headerCart = header.querySelector('.header__actions [data-cart-toggle]');
        if (!headerCart) return;
        event.preventDefault();
        closeDrawer();
        setTimeout(() => headerCart.click(), 260);
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  document.querySelectorAll('.product').forEach((root) => {
    const jsonTag = root.parentElement.querySelector('[data-product-json]');
    const variants = jsonTag ? JSON.parse(jsonTag.textContent) : [];
    const form = root.querySelector('form[action*="/cart/add"]');
    const priceEl = root.querySelector('[data-product-price]');
    const addButton = root.querySelector('[data-add-button]');
    const idInput = root.querySelector('[data-variant-id]');

    function selectedOptions() {
      return Array.from(root.querySelectorAll('.product__option-input:checked'))
        .sort((a, b) => a.dataset.optionPosition - b.dataset.optionPosition)
        .map((input) => input.value);
    }

    function onOptionChange() {
      const options = selectedOptions();
      const variant = variants.find((v) => v.options.every((value, index) => value === options[index]));
      if (!variant) return;
      idInput.value = variant.id;
      if (priceEl) {
        priceEl.textContent = (variant.price / 100).toLocaleString(undefined, {
          style: 'currency',
          currency: window.Shopify && Shopify.currency ? Shopify.currency.active : 'USD',
        });
      }
      addButton.disabled = !variant.available;
      addButton.textContent = variant.available ? addButton.dataset.addText : addButton.dataset.soldText;
    }

    if (form) {
      root.querySelectorAll('.product__option-input').forEach((input) => {
        input.addEventListener('change', onOptionChange);
      });

      const errorEl = root.querySelector('[data-add-error]');

      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (addButton.disabled) return;
        addButton.disabled = true;
        errorEl.hidden = true;
        try {
          const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
            method: 'POST',
            body: new FormData(form),
          });
          const payload = await response.json();
          if (!response.ok) {
            errorEl.textContent = payload.description || payload.message || 'Unable to add to cart.';
            errorEl.hidden = false;
            return;
          }
          document.dispatchEvent(new CustomEvent('cart:changed', { detail: { open: true } }));
        } catch (error) {
          errorEl.textContent = 'Unable to add to cart.';
          errorEl.hidden = false;
        } finally {
          addButton.disabled = false;
          onOptionChange();
        }
      });
    }

    const carousel = root.querySelector('[data-carousel]');
    const dots = Array.from(root.querySelectorAll('[data-dot]'));
    if (carousel && dots.length > 1) {
      const slides = Array.from(carousel.children);

      dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
          slides[index].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        });
      });

      carousel.addEventListener(
        'scroll',
        () => {
          const index = Math.round(carousel.scrollLeft / carousel.clientWidth);
          dots.forEach((dot, i) => {
            if (i === index) {
              dot.setAttribute('aria-current', 'true');
            } else {
              dot.removeAttribute('aria-current');
            }
          });
        },
        { passive: true }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-video-stage]').forEach((stage) => {
    const playButton = stage.querySelector('[data-video-play]');
    const template = stage.querySelector('[data-video-template]');
    if (!playButton || !template) return;

    playButton.addEventListener('click', () => {
      let video = stage.querySelector(':scope > video');
      if (!video) {
        stage.appendChild(template.content.cloneNode(true));
        video = stage.querySelector(':scope > video');
        video.setAttribute('controls', '');
        video.setAttribute('controlslist', 'nodownload');
      }
      stage.classList.add('is-playing');
      video.play();
    });
  });

  } catch(e) { console.error(e); }
})();
})();
